import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCommonModule, MatOptionModule } from '@angular/material/core';
import { AppAutocompleteTriggerDirective } from './app-autocomplete-trigger.directive';

@NgModule({
  imports: [MatOptionModule, OverlayModule, MatCommonModule, CommonModule, MatAutocompleteModule],
  exports: [AppAutocompleteTriggerDirective],
  declarations: [AppAutocompleteTriggerDirective]
})
export class AppAutoCompleteModule {}
